export default {
	// Publication
	padApi:
		'/resource/PAD?fields=[%22image%22,%22title%22,%22description%22,%22attachment%22] ',
	studyReportsApi:
		'/resource/Study%20Reports?fields=[%22image%22,%22title%22,%22description%22,%22attachment%22] ',
	meetingMinutesApi:
		'/resource/Meeting%20Minutes?fields=[%22image%22,%22title%22,%22description%22,%22attachment%22] ',
	projectDocumentsApi:
		'/resource/Project%20Documents?fields=[%22image%22,%22title%22,%22description%22,%22attachment%22] ',

	//  BeneficiaryCorner

	technicalOfficerApi:
		'/resource/Technical%20Officer?fields=[%20%22title%22,%20%22description%22,%20%22image%22,%20%22url%22]',
	farmersApi:
		'/resource/Farmers?fields=[%20%22title%22,%20%22description%22,%20%22image%22,%20%22url%22]',
	FPOFPCApi:
		'/resource/FPO-FPC?fields=[%20%22title%22,%20%22description%22,%20%22image%22,%20%22url%22]',
	agriBusinessPartnerApi:
		'/resource/Agri%20Business%20Partner?fields=[%20%22title%22,%20%22description%22,%20%22image%22,%20%22url%22]',
	MSMEApi:
		'/resource/MSME?fields=[%20%22title%22,%20%22description%22,%20%22image%22,%20%22url%22]&limit_page_length=0',
	startupApi:
		'/resource/Startup?fields=[%20%22title%22,%20%22description%22,%20%22image%22,%20%22url%22]&limit_page_length=0',

	// Team

	teamApi:
		'/resource/Team%20List?fields=[%22full_name%22,%22designation%22,%22email_id%22,%22phone_no%22,%22image%22,%22branch%22,%22rank%22]&order_by=rank%20desc&limit_page_length=0 ',

	// / EOI tenders

	EOIApi:
		'/resource/EOI-Tenders?fields=[%22name%22,%22file%22,%22description%22,%22url%22,%22published_date%22,%22last_date%22]&limit_page_length=6&',
	TotalPagesApi: '/method/frappe.client.get_count?doctype=EOI-Tenders',

	// Home Page

	MainImgApi:
		'https://kera.enfonoerp.com/api/resource/Home%20Slider%20Images?fields=%5B"image"%5D&limit_page_length=0',
	ProjectCompApi:
		'https://kera.enfonoerp.com/api/resource/Project%20Components?fields=[%22title%22,%22image%22,%22description%22]&limit_page_length=0',

	// About
	KeyCompApi:
		'https://kera.enfonoerp.com/api/resource/Key%20Components?fields=[%22title%22,%22image%22,%22description%22]&limit_page_length=0',

	// Gallery
	PhotoGalleyApi:
		'https://kera.enfonoerp.com/api/resource/Photo%20Gallery?fields=[%22image%22,%22description%22]&limit_page_length=0',
	VideoGalleyApi:
		'https://kera.enfonoerp.com/api/resource/Video%20Gallery?fields=[%22image%22,%22description%22,%22url%22]&limit_page_length=0',
	MediaGalleyApi:
		'https://kera.enfonoerp.com/api/resource/KERA%20in%20Media?fields=[%22image%22,%22description%22]&limit_page_length=0',
};
